import { get } from "./api";

export type Overview = {
  companyCount: number;
  questionCount: { active: number; inactive: number };
  testTakers: { completed: number; outstanding: number; total: number };
  questionsByApp: { app: string; count: number }[];
  questionsByAppType: { appType: string; count: number }[];
  questionsByPackage: { packageCode: string; label: string; count: number }[];
  feedback: {
    choiceQuestions: {
      questionId: string;
      text: string;
      options: { option: string; count: number; percent: number }[];
    }[];
    freeTextQuestions: { questionId: string; text: string; answers: string[] }[];
  };
};

export type OverviewFilters = {
  company?: string;
  app?: string;
  appType?: string;
  package?: string;
};

/** FR-088: the CO Member Home report. Platform-wide by default; any filter narrows it. */
export function getOverview(filters: OverviewFilters = {}) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value) params.set(key, value);
  }
  const qs = params.toString();
  return get<Overview>(`/co/overview${qs ? `?${qs}` : ""}`);
}
